import { render, staticRenderFns } from "./PurScL.vue?vue&type=template&id=6376dd5e"
import script from "./PurScL.vue?vue&type=script&lang=js"
export * from "./PurScL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports